/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Sections_Topsellingoffers2Inputs */

const id_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penawaran Terlaris`)
};

const ms_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tawaran Terlaris`)
};

const da_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedst Sælgende Tilbud`)
};

const de_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meistverkaufte Angebote`)
};

const en_us2_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Top‑Selling Offers`)
};

const es_es2_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juegos más vendidos`)
};

const es_mx2_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas más vendidas`)
};

const fil_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Pinakamabentang Offer`)
};

const fr_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offres les plus vendues`)
};

const it_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offerte più vendute`)
};

const hu_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legkelendőbb ajánlatok`)
};

const nl_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Best verkopende aanbiedingen`)
};

const no_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mest solgte tilbud`)
};

const pl_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Najlepiej sprzedawane oferty`)
};

const pt_br2_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jogos mais vendidos`)
};

const pt_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ofertas mais vendidas`)
};

const ro_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oferte best-seller`)
};

const fi_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Myydyimmät tarjoukset`)
};

const sv_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bästsäljande erbjudanden`)
};

const vi_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ưu đãi bán chạy nhất`)
};

const tr_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En Çok Satan Teklifler`)
};

const cs_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejprodávanější nabídky`)
};

const bg_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Най-продавани оферти`)
};

const ru_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Самые продаваемые предложения`)
};

const uk_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Найпродаваніші пропозиції`)
};

const ar_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`العروض الأكثر مبيعًا`)
};

const hi_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टॉप-सेलिंग ऑफ़र`)
};

const th_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อเสนอขายดีที่สุด`)
};

const ja_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ベストセラーオファー`)
};

const zh_cn2_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`畅销目录项`)
};

const zh_hant1_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暢銷目錄項目`)
};

const ko_home_sections_topsellingoffers2 = /** @type {(inputs: Home_Sections_Topsellingoffers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`최고 판매 오퍼`)
};

/**
* | output |
* | --- |
* | "Top‑Selling Offers" |
*
* @param {Home_Sections_Topsellingoffers2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const home_sections_topsellingoffers2 = /** @type {((inputs?: Home_Sections_Topsellingoffers2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Sections_Topsellingoffers2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_home_sections_topsellingoffers2(inputs)
	if (locale === "ms") return ms_home_sections_topsellingoffers2(inputs)
	if (locale === "da") return da_home_sections_topsellingoffers2(inputs)
	if (locale === "de") return de_home_sections_topsellingoffers2(inputs)
	if (locale === "en-US") return en_us2_home_sections_topsellingoffers2(inputs)
	if (locale === "es-ES") return es_es2_home_sections_topsellingoffers2(inputs)
	if (locale === "es-MX") return es_mx2_home_sections_topsellingoffers2(inputs)
	if (locale === "fil") return fil_home_sections_topsellingoffers2(inputs)
	if (locale === "fr") return fr_home_sections_topsellingoffers2(inputs)
	if (locale === "it") return it_home_sections_topsellingoffers2(inputs)
	if (locale === "hu") return hu_home_sections_topsellingoffers2(inputs)
	if (locale === "nl") return nl_home_sections_topsellingoffers2(inputs)
	if (locale === "no") return no_home_sections_topsellingoffers2(inputs)
	if (locale === "pl") return pl_home_sections_topsellingoffers2(inputs)
	if (locale === "pt-BR") return pt_br2_home_sections_topsellingoffers2(inputs)
	if (locale === "pt") return pt_home_sections_topsellingoffers2(inputs)
	if (locale === "ro") return ro_home_sections_topsellingoffers2(inputs)
	if (locale === "fi") return fi_home_sections_topsellingoffers2(inputs)
	if (locale === "sv") return sv_home_sections_topsellingoffers2(inputs)
	if (locale === "vi") return vi_home_sections_topsellingoffers2(inputs)
	if (locale === "tr") return tr_home_sections_topsellingoffers2(inputs)
	if (locale === "cs") return cs_home_sections_topsellingoffers2(inputs)
	if (locale === "bg") return bg_home_sections_topsellingoffers2(inputs)
	if (locale === "ru") return ru_home_sections_topsellingoffers2(inputs)
	if (locale === "uk") return uk_home_sections_topsellingoffers2(inputs)
	if (locale === "ar") return ar_home_sections_topsellingoffers2(inputs)
	if (locale === "hi") return hi_home_sections_topsellingoffers2(inputs)
	if (locale === "th") return th_home_sections_topsellingoffers2(inputs)
	if (locale === "ja") return ja_home_sections_topsellingoffers2(inputs)
	if (locale === "zh-CN") return zh_cn2_home_sections_topsellingoffers2(inputs)
	if (locale === "zh-Hant") return zh_hant1_home_sections_topsellingoffers2(inputs)
	return ko_home_sections_topsellingoffers2(inputs)
});
export { home_sections_topsellingoffers2 as "home.sections.topSellingOffers" }